import {Eye} from "react-feather";
import {useAppSelector} from "hooks";
import {useTheme} from "styled-components";
import {buildAvatarPlaceholder} from "utils";
import {useNavigate} from "react-router-dom";
import {TableRow, TableCell, TableBody} from "@mui/material";
import {Avatar, IconButton, Row, Typography} from "components";

interface BodyProps {}

export const Body: React.FC<BodyProps> = () => {
  const push = useNavigate();
  const {blackWhite} = useTheme();
  const {clients} = useAppSelector("clients");

  return (
    <TableBody>
      {clients.map((client, key) => {
        const {id, email, nombre, apellido, cedula, telefono} = client;

        return (
          <TableRow hover key={`${id}-${key}`} tabIndex={-1}>
            <TableCell padding="none">
              <Row alignItems="center">
                <Avatar size={35} src={buildAvatarPlaceholder(nombre)} />
                <Typography className="line-clamp-1">
                  {nombre} {apellido}
                </Typography>
              </Row>
            </TableCell>
            <TableCell>
              <Typography>{cedula}</Typography>
            </TableCell>
            <TableCell>
              <Typography className="line-clamp-1">{email}</Typography>
            </TableCell>
            <TableCell>
              <Typography className="line-clamp-1">{telefono}</Typography>
            </TableCell>
            <TableCell align="right">
              <IconButton
                toolTip="Ver usuario"
                icon={<Eye color={blackWhite} />}
                onClick={() => {
                  push(`/clients/${id}`);
                }}
              />
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};
